export default __webpack_public_path__ + "static/media/logoHogasia.a7915187.jpg";